module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg.3ca30542.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg.png
// module id = 3406
// module chunks = 11